import { Card } from "antd";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import formatMoney from "../../../utils/formatMoney";
import { MetricInfo, buildMetricDocs } from "./dashboard-metric-info";

// Brand-matching colors per platform
const PLATFORM_COLORS = {
    shopee: "#ee4d2d",
    tiktok: "#010101",
    lazada: "#0f146d",
    shopeefood: "#ff7a00",
};
const FALLBACK_COLORS = ["#2563eb", "#16a34a", "#ea580c", "#7c3aed"];

function DashboardPlatformChart({ platforms, timeField = "purchase" }) {
    const docs = buildMetricDocs(timeField);
    const data = (platforms || [])
        .filter((p) => Number(p.total) > 0)
        .map((p) => ({
            name: p.campId.charAt(0).toUpperCase() + p.campId.slice(1),
            value: Number(p.total),
            campId: p.campId,
        }));

    return (
        <Card
            title={
                <span className="flex items-center gap-1.5">
                    Tỷ lệ theo sàn
                    <MetricInfo doc={docs.platformChart} />
                </span>
            }
            className="shadow-sm h-full"
        >
            {data.length === 0 ? (
                <div className="flex items-center justify-center h-48 text-content-3 text-sm">
                    Chưa có dữ liệu
                </div>
            ) : (
                <ResponsiveContainer width="100%" height={260}>
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="45%"
                            innerRadius={55}
                            outerRadius={85}
                            dataKey="value"
                            nameKey="name"
                        >
                            {data.map((entry, index) => (
                                <Cell
                                    key={entry.campId}
                                    fill={
                                        PLATFORM_COLORS[entry.campId] ||
                                        FALLBACK_COLORS[index % FALLBACK_COLORS.length]
                                    }
                                />
                            ))}
                        </Pie>
                        <Tooltip formatter={(value) => formatMoney.format(value)} />
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            )}
        </Card>
    );
}

export default DashboardPlatformChart;
